import customerReducer from 'store/customer/slice'
import appReducer from 'store/app/slice'
import marketingReducer from 'store/marketing/slice'
import { boltApi } from 'store/api/bolt-api'
import { cmsApi } from 'store/api/cms-api'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { IS_PROD } from 'constants/envs'
import { createReduxEnhancer } from '@sentry/nextjs'
import { actionTransformer, stateTransformer } from 'store/utils'

const sentryReduxEnhancer = createReduxEnhancer({ stateTransformer, actionTransformer })

const rootReducer = combineReducers({
  app: appReducer,
  customer: customerReducer,
  marketing: marketingReducer,
  [boltApi.reducerPath]: boltApi.reducer,
  [cmsApi.reducerPath]: cmsApi.reducer
})

export const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat([boltApi.middleware, cmsApi.middleware]),
  reducer: rootReducer,
  devTools: !IS_PROD,
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer)
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
